<template>
    <div>
        <div class="progress my-3">
          <div class="progress-bar " role="progressbar" :style="'width:' + progressPercen + '%'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{progressPercen}}%</div>
        </div>
        <div class="d-flex justify-content-around">
            <!-- <button class="btn btn-lg btn-info btn-block-cyan" @click="backPage" v-if="14 != page">
                ย้อนกลับ -- {{ page }}
            </button> -->
            <button class="btn btn-lg btn-info btn-block-cyan" @click="nextPage" v-if="useButton && 13 > page">
                ถัดไป
            </button>
            <button class="btn btn-lg btn-info btn-block-cyan" @click="initFormNimcap()" v-if="1 == page" >สมัคร</button>
            <button class="btn btn-lg btn-info btn-block-cyan" @click="saveConfirmPDPA()" v-if="2 == page" :disabled="!borrowerConfirmBtn" >ยินยอม</button>
            <button class="btn btn-lg btn-info btn-block-cyan" @click="nextPage" v-if="3 == page" >เริ่มต้น</button>
            <button class="btn btn-lg btn-info btn-block-cyan" @click="saveImageIDCard()" v-if="4 == page" :disabled="!imageIdCardConfirmBtn" >ถัดไป</button>
            <button class="btn btn-lg btn-info btn-block-cyan" @click="saveFaceWithIdCardImage()" v-if="5 == page" :disabled="!faceWithIdCardImageConfirmBtn" >ถัดไป</button>
            <button class="btn btn-lg btn-info btn-block-cyan" @click="saveSignature()"  v-if="6 == page" :disabled="!signatureConfirmBtn" >ยืนยัน</button>
            <!--  -->
            <button class="btn btn-lg btn-info btn-block-cyan" @click="saveGuarantorConfirmPDPA()" v-if="7 == page" :disabled="!guarantorConfirmBtn" >ยินยอม</button>
            <button class="btn btn-lg btn-info btn-block-cyan" @click="saveGuarantorImageIDCard()" v-if="8 == page" :disabled="!guarantorImageIdCardConfirmBtn" >ถัดไป</button>
            <button class="btn btn-lg btn-info btn-block-cyan" @click="saveGuarantorFaceWithIdCardImage()" v-if="9 == page" :disabled="!guarantorFaceWithIdCardImageConfirmBtn" >ถัดไป</button>
            <button class="btn btn-lg btn-info btn-block-cyan" @click="saveSignatureConfirm()" v-if="10 == page" :disabled="!guarantorSignatureConfirmBtn" >ยืนยัน</button>
            <button class="btn btn-lg btn-info btn-block-cyan" @click="nextPage" v-if="11 == page" >ตรวจสอบรายละเอียดการกู้</button>
            <!--  -->
            <button class="btn btn-lg btn-info btn-block-cyan" @click="saveFormNimcap" v-if="13 == page" >บันทึก</button>
            
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
export default {
  props: {page: Number},
  data: () => ({
    useButton: true,
    progressPercen: 0
  }),
  watch: {
    page (newValue, oldValue) {
      const pageConfirmButton = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13]
      if (newValue <= 13) {
        // เช็คหน้า ปัจจุบันคือหน้าใน arr หรือไม่
        let buttonOther = pageConfirmButton.filter(number => number === newValue)
        this.useButton = buttonOther.length === 0 // true || false
        if (newValue === 0) {
          this.useButton = true
        }
      }

      if (newValue > oldValue && newValue <= 13) {
        if (newValue === 13) {
          this.progressPercen = ((newValue - 3) * 10)
        } else {
          this.progressPercen = (newValue * 8)
        }
      }
      if (newValue < oldValue && newValue >= 0) {
        if (newValue === 13) {
          this.progressPercen = ((newValue - 3) * 10)
        } else {
          this.progressPercen = (newValue * 8)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      nimcapDetils: 'nimcap/GET_DETAILS'
    }),
    borrowerConfirmBtn: {
      get () {
        return this.nimcapDetils.borrowerImage.confirmPDPA
      }
    },
    imageIdCardConfirmBtn: {
      get () {
        return !!this.nimcapDetils.borrowerImage.imageIdCard
      }
    },
    faceWithIdCardImageConfirmBtn: {
      get () {
        return !!this.nimcapDetils.borrowerImage.faceWithIdCardImage
      }
    },
    signatureConfirmBtn: {
      get () {
        return !!this.nimcapDetils.borrowerImage.signature
      }
    },
    // guarantor
    guarantorConfirmBtn: {
      get () {
        return !!this.nimcapDetils.guarantorImage.confirmPDPA
      }
    },
    guarantorImageIdCardConfirmBtn: {
      get () {
        return !!this.nimcapDetils.guarantorImage.imageIdCard
      }
    },
    guarantorFaceWithIdCardImageConfirmBtn: {
      get () {
        return !!this.nimcapDetils.guarantorImage.faceWithIdCardImage
      }
    },
    guarantorSignatureConfirmBtn: {
      get () {
        return !!this.nimcapDetils.guarantorImage.signature
      }
    }
  },
  methods: {
    ...mapActions({
      SET_EL_VALUE: 'nimcap/SET_EL_VALUE'
    }),
    nextPage () {
      this.$emit('next-page', 1)
    },
    backPage () {
      this.$emit('back-page', 1)
    },
    submitBtn () {
      this.$emit('submit-btn', '')
    },
    async image (dataImage, columnImage, stateSubmit, action) {
      try {
        let formData = new FormData()
        formData.append('nimcap_id', this.nimcapDetils.nimcapId)
        formData.append('image', dataImage)
        formData.append('column_db_img', columnImage)
        formData.append('column_db_state_submit', 'state_submit')
        formData.append('state_submit', stateSubmit)
        formData.append('action', action)
        const { data } = await axios.post('/nimcap/image', formData)
        if (!data.error) {
          let payload = {
            main_key: 'stateSubmit',
            value: stateSubmit
          }
          this.SET_EL_VALUE(payload)
          if (columnImage === 'face_with_id_card_image') {
            let payloadMergeUrl = {
              main_key: 'mergeUrl',
              value: data.nimcap.merge_url
            }
            this.SET_EL_VALUE(payloadMergeUrl)
          }
          if (columnImage === 'guarantor_face_with_id_card_image') {
            let payloadGuarantorMergeUrl = {
              main_key: 'guarantorMergeUrl',
              value: data.nimcap.merge_url
            }
            this.SET_EL_VALUE(payloadGuarantorMergeUrl)
          }
          this.nextPage()
        }
      } catch (error) {
        console.log(error)
      }
    },
    async detail (items, action) {
      try {
        let formData = new FormData()
        formData.append('items', JSON.stringify(items))
        formData.append('nimcap_id', this.nimcapDetils.nimcapId)
        formData.append('action', action)
        const { data } = await axios.post('/nimcap/detail', formData)
        if (!data.error) {
          let payload = {
            main_key: 'stateSubmit',
            value: items.state_submit
          }
          this.SET_EL_VALUE(payload)
          if (action === 'create') {
            let payload = {
              main_key: 'nimcapId',
              value: data.nimcap.id
            }
            this.SET_EL_VALUE(payload)
          }
          this.nextPage()
        }
      } catch (error) {
        console.log(error)
      }
    },
    initFormNimcap () {
      const items = [
        {professional_id: this.nimcapDetils.professionalId},
        {state_submit: 1}
      ]
      const action = 'create'
      this.detail(items, action)
    },
    saveConfirmPDPA () {
      const items = [
        {confirmed_pdpa: this.nimcapDetils.borrowerImage.confirmPDPA},
        {state_submit: 2}
      ]
      const action = 'update'
      this.detail(items, action)
    },
    saveImageIDCard () {
      const dataImage = this.nimcapDetils.borrowerImage.imageIdCard
      const columnImage = 'id_card_image'
      const stateSubmit = 4
      const action = 'update'
      this.image(dataImage, columnImage, stateSubmit, action)
    },
    saveFaceWithIdCardImage () {
      const dataImage = this.nimcapDetils.borrowerImage.faceWithIdCardImage
      const columnImage = 'face_with_id_card_image'
      const stateSubmit = 5
      const action = 'update'
      this.image(dataImage, columnImage, stateSubmit, action)
    },
    saveSignature () {
      const dataImage = this.nimcapDetils.borrowerImage.signature
      const columnImage = 'signature'
      const stateSubmit = 6
      const action = 'update'
      this.image(dataImage, columnImage, stateSubmit, action)
    },
    saveGuarantorConfirmPDPA () {
      const items = [
        {guarantor_confirmed_pdpa: this.nimcapDetils.guarantorImage.confirmPDPA},
        {state_submit: 7}
      ]
      const action = 'update'
      this.detail(items, action)
    },
    saveGuarantorImageIDCard () {
      const dataImage = this.nimcapDetils.guarantorImage.imageIdCard
      const columnImage = 'guarantor_id_card_image'
      const stateSubmit = 8
      const action = 'update'
      this.image(dataImage, columnImage, stateSubmit, action)
    },
    saveGuarantorFaceWithIdCardImage () {
      const dataImage = this.nimcapDetils.guarantorImage.faceWithIdCardImage
      const columnImage = 'guarantor_face_with_id_card_image'
      const stateSubmit = 9
      const action = 'update'
      this.image(dataImage, columnImage, stateSubmit, action)
    },
    saveSignatureConfirm () {
      const dataImage = this.nimcapDetils.guarantorImage.signature
      const columnImage = 'guarantor_signature'
      const stateSubmit = 10
      const action = 'update'
      this.image(dataImage, columnImage, stateSubmit, action)
    },
    saveFormNimcap () {
      const _ = this.nimcapDetils
      const items = [
        {professional_id: _.professionalId},
        {birthday: _.birthday}, //  auto
        {age: _.age}, //  auto
        {nationality: _.nationality},
        {id_card_expire_date: _.idcardExpireDate},
        {marriage_status: _.marriageStatus},
        {living_status: _.livingStatus},
        {building: _.currentAddress.building}, // auto
        {room_no: _.currentAddress.roomNo}, // auto
        {address: _.currentAddress.address}, // auto
        {moo: _.currentAddress.moo}, // auto
        {soi: _.currentAddress.soi}, // auto
        {road: _.currentAddress.road}, // auto
        {phone: _.phone},
        {email: _.email}, // auto
        {line_id: _.lineId}, // auto
        {facebook: _.facebook}, // auto
        {decition_doc_channel: _.documentsReceive},
        {office_building: _.office.building},
        {office_room_no: _.office.roomNo},
        {office_address: _.office.address},
        {office_moo: _.office.moo},
        {office_soi: _.office.soi},
        {office_road: _.office.road},
        {office_phone: _.office.phone},
        {office_business_type: _.office.businessType},
        {income: _.income},
        {other_income: _.otherIncome},
        {income_source: _.incomeSource},
        {other_income_source: _.otherIncomeSource},
        {invoice_location: _.invoiceLocation},
        {campaign: _.campaign},
        {loan_amount: _.loanAmt},
        {loan_installment: _.loanInstallment},
        // {confirmed_pdpa: ''},
        // {id_card_image: ''},
        // {face_with_id_card_image: ''},
        // {signature: ''},
        {guarantor_prename: _.guarantor.prename},
        {guarantor_name: _.guarantor.thaiName},
        {guarantor_age: _.guarantor.age},
        {guarantor_origin: _.guarantor.origin},
        {guarantor_nationality: _.guarantor.nationality},
        {guarantor_building: _.guarantor.building},
        {guarantor_room_no: _.guarantor.roomNo},
        {guarantor_address: _.guarantor.address},
        {guarantor_moo: _.guarantor.moo},
        {guarantor_soi: _.guarantor.soi},
        {guarantor_road: _.guarantor.road},
        {guarantor_id_card_number: _.guarantor.idcard},
        // {guarantor_confirmed_pdpa: ''},
        // {guarantor_id_card_image: ''},
        // {guarantor_face_with_id_card_image: ''},
        // {guarantor_signature: ''},
        {state_submit: 11}
      ]
      const validItems = [
        {product_code: _.productCode}, // * auto
        {branch_code: _.branchCode}, // * auto
        {partner_ref_no: _.partnerRefNo}, // * auto
        {prename_th: _.prenameThai}, // * auto
        {name_th: _.thaiName}, // * auto
        {prename_en: _.prenameEng}, // *  auto
        {name_en: _.engName}, // * auto
        {id_card_number: _.idcard}, // *  auto
        {mobile: _.mobile}, // * auto
        {subdistrict_name: _.currentAddress.subDistrictName}, // *
        {district_name: _.currentAddress.districtName}, // *
        {province_name: _.currentAddress.provinceName}, // *
        {zipcode: _.currentAddress.zipcode}, // *
        {occupation_name: _.occupation}, // *
        {office_name: _.office.name}, // *
        {account_name: _.accountName}, // * auto
        {bank_code: _.bankCode}, // * auto
        {bank_account_no: _.bankAccountNo}, // * auto
        {office_subdistrict_name: _.office.subDistrictName}, // *
        {office_district_name: _.office.districtName}, // *
        {office_province_name: _.office.provinceName}, // *
        {office_zipcode: _.office.zipcode}, // *
        {guarantor_subdistrict_name: _.guarantor.subDistrictName}, // *
        {guarantor_district_name: _.guarantor.districtName}, // *
        {guarantor_province_name: _.guarantor.provinceName}, // *
        {guarantor_zipcode: _.guarantor.zipcode} // *
      ]
      if (this.isArrayObjectEmpty(validItems)) {
        const updateItems = items.concat(validItems)
        const action = 'update'
        this.detail(updateItems, action)
        this.submitBtn()
      } else {
        this.$swal({
          type: 'error',
          text: 'กรุณาตรวจสอบการกรอกข้อมูลให้ถูกต้อง'
        })
      }
    },
    isArrayObjectEmpty (items) {
      for (let i = 0; i < items.length; i++) {
        let element = items[i]
        if (Object.values(element)[0]) {
          return true
        } else {
          return false
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/nimcap/Components/ProgressStep.vue